var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSidebarIcon2 = function SvgSidebarIcon2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.00195312,
    width: 18,
    height: 18,
    rx: 9,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.86607 7.13905C6.91647 5.69005 7.84887 5.12305 8.99547 5.12305C10.1673 5.12305 11.1375 5.91685 11.1375 7.06345V7.50445C11.1375 8.42425 10.4319 9.12985 9.78927 9.74725C9.19707 10.3142 8.60487 10.8938 8.60487 11.738H10.5957C10.7217 11.738 10.8351 11.8514 10.8351 11.99V12.746C10.8351 12.8846 10.7217 12.998 10.5957 12.998H7.14327C7.01727 12.998 6.90387 12.8846 6.90387 12.746V11.801C6.90387 10.541 7.76067 9.67165 8.49147 8.99125C9.08367 8.43685 9.62547 7.89505 9.62547 7.23985V7.03825C9.61287 6.68545 9.37347 6.38305 8.99547 6.38305C8.63007 6.38305 8.39067 6.53425 8.37807 7.13905C8.37807 7.26505 8.26467 7.37845 8.12607 7.37845H7.11807C6.97947 7.37845 6.86607 7.26505 6.86607 7.13905Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSidebarIcon2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sidebar-icon-2.eea2a21d.svg";
export { ForwardRef as ReactComponent };